import uuid from "uuid";

class SessionId {
    constructor() {
        this._id = uuid.v4();
    }

    getId() {
        return this._id;
    }
}

export default new SessionId();